import { UserTypes } from '../components/profile/profile.enum';
import { FullUser } from '../swagger-api';
import { MaybeNull } from '../utils';

export interface Session {
  token: MaybeNull<string>;
  user: MaybeNull<FullUser>;
  userId: MaybeNull<string>;
  userType: UserTypes;
  secondAuthLvl: boolean;
  adminSession: boolean;
  lastProlongedTime: number;
}
